import React, { memo } from "react";

const Mine = memo(() => {
  return (
    <div>
      <h2>我的音乐</h2>
    </div>
  );
});

export default Mine;
